// PORTFOLIO — per aggiungere un progetto copia un oggetto e modifica i campi.
// `services` usa gli id di SERVICES (social, produzione, ads, lancio) e alimenta i filtri.
// `tags` sono le competenze mostrate sulla scheda. `home: true` lo mostra in Home.
// `more` (facoltativo) aggiunge paragrafi nella pagina del progetto.
// Le immagini attuali sono riferimenti visivi indicativi, non foto originali dei clienti.
export const PROJECTS = [
  {
    slug: "elevate-saronno",
    title: "ELEVATE",
    place: "Saronno",
    sector: "Sport e fitness",
    tagline: "Dal rebranding al lancio di una nuova identità.",
    text: "Un progetto che va oltre la comunicazione di una palestra. Abbiamo accompagnato l'evoluzione di CrossFit Saronno in ELEVATE, lavorando sulla narrazione del cambiamento, sulla creazione di contenuti e sulla promozione della nuova struttura.",
    tags: ["Social Media Strategy", "Content Creation", "Rebranding Communication", "ADV"],
    services: ["social", "produzione", "lancio", "ads"],
    cover: "/img/proj/elevate-1.webp",
    gallery: ["/img/proj/elevate-2.webp", "/img/proj/ndo-1.webp"],
    home: true,
  },
  {
    slug: "al-murett-cermenate",
    title: "Al Murett",
    place: "Cermenate",
    sector: "Food e ristorazione",
    tagline: "La tradizione lombarda raccontata sui social.",
    text: "Un'osteria dove la tradizione incontra una comunicazione autentica. Per Al Murett, osteria di Cermenate, abbiamo costruito una comunicazione social capace di valorizzare l'identità del locale: la cucina lombarda, la pasta fresca fatta in casa, le ricette della tradizione e il piacere di ritrovarsi a tavola.",
    more: [
      "Attraverso una strategia editoriale dedicata, contenuti fotografici, Reel e storytelling, raccontiamo non soltanto i piatti, ma anche le persone, la passione e il lavoro che si nascondono dietro ogni preparazione.",
      "L'obiettivo è trasformare i social in una vetrina autentica del ristorante, rafforzandone la riconoscibilità sul territorio e creando un legame con chi ama la buona cucina.",
    ],
    tags: ["Strategia social", "Gestione Instagram e Facebook", "Produzione foto e video", "Reel", "Copywriting", "Storytelling"],
    services: ["social", "produzione"],
    cover: "/img/proj/murett-chef.webp",
    gallery: ["/img/proj/murett-2.webp", "/img/proj/murett-3.webp"],
  },
  {
    slug: "playoff-sport-events",
    title: "PlayOff Sport Events",
    place: "",
    sector: "Sport e fitness",
    tagline: "Un'estate da vivere. Una storia da raccontare.",
    text: "Comunicare il mondo dei camp estivi significa parlare ai genitori, ma anche raccontare esperienze, emozioni e opportunità di crescita. Un progetto che unisce storytelling, contenuti informativi e strategie di promozione.",
    tags: ["Strategia Digitale", "Content Creation", "Campagne Promozionali"],
    services: ["social", "produzione", "ads"],
    cover: "/img/proj/playoff-1.webp",
    gallery: ["/img/proj/playoff-2.webp"],
    home: true,
  },
  {
    slug: "rassegna-selvatica",
    title: "Rassegna Selvatica",
    place: "Territorio comasco",
    sector: "Eventi e territorio",
    tagline: "Quando il territorio diventa una storia.",
    text: "Un progetto di comunicazione dedicato alla valorizzazione della cultura gastronomica e delle tradizioni del territorio comasco. Attraverso interviste, video, storytelling e campagne digitali abbiamo contribuito a raccontare persone, luoghi e sapori.",
    tags: ["Storytelling", "Video Production", "Social Media Management", "ADV"],
    services: ["social", "produzione", "ads"],
    cover: "/img/proj/selvatica-1.webp",
    gallery: ["/img/proj/selvatica-2.webp"],
    home: true,
  },
  {
    slug: "festival-del-legno-cantu",
    title: "Festival del Legno",
    place: "Cantù",
    sector: "Eventi e territorio",
    tagline: "Raccontare una tradizione che guarda al futuro.",
    text: "Un evento che celebra il saper fare, il design e l'identità di un territorio. La nostra comunicazione ha dato spazio ai protagonisti, agli eventi e alle storie che rendono Cantù un punto di riferimento nel mondo del legno e dell'arredo.",
    tags: ["Comunicazione Eventi", "Social Media", "Produzione Contenuti"],
    services: ["social", "produzione"],
    cover: "/img/proj/legno-1.webp",
    gallery: ["/img/proj/legno-2.webp"],
  },
  {
    slug: "panificio-longoni",
    title: "Panificio F.lli Longoni",
    place: "",
    sector: "Food e ristorazione",
    tagline: "Una storia dal 1961, raccontata con un linguaggio contemporaneo.",
    text: "Come si comunica una tradizione artigianale senza perdere autenticità? Attraverso le persone, i gesti quotidiani, i prodotti e una buona dose di ironia. Un racconto che porta sui social il profumo del pane appena sfornato.",
    tags: ["Social Media Management", "Reel Production", "Brand Storytelling"],
    services: ["social", "produzione"],
    cover: "/img/proj/longoni-1.webp",
    gallery: ["/img/proj/longoni-2.webp"],
    home: true,
  },
  {
    slug: "boom-pizzeria",
    title: "BOOM Pizzeria",
    place: "",
    sector: "Food e ristorazione",
    tagline: "Non solo pizza. Un brand che sa farsi ricordare.",
    text: "Contenuti divertenti, persone vere e una comunicazione che valorizza l'esperienza del locale. Un progetto in cui intrattenimento e promozione si incontrano per costruire riconoscibilità e vicinanza con il pubblico.",
    tags: ["Social Media Strategy", "Content Creation", "Reel Production"],
    services: ["social", "produzione"],
    cover: "/img/proj/boom-1.webp",
    gallery: ["/img/proj/boom-2.webp"],
  },
  {
    slug: "sensation-hair-studio",
    title: "Sensation Hair Studio",
    place: "",
    sector: "Beauty",
    tagline: "La personalità di un salone diventa comunicazione.",
    text: "Un racconto fatto di competenza, ironia e vita quotidiana. Attraverso format riconoscibili e contenuti pensati per il pubblico, valorizziamo il team, i servizi e l'identità del salone.",
    tags: ["Social Media Management", "Video Content", "Strategia Editoriale"],
    services: ["social", "produzione"],
    cover: "/img/proj/sensation-1.webp",
    gallery: ["/img/proj/sensation-2.webp"],
  },
];

export const SECTORS = [...new Set(PROJECTS.map((p) => p.sector))];
